import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { AppRoutes } from "@/routes/AppRoutes";
import { useAppSelector } from "@/store/hooks";
import { setSchoolTimezone } from "@/lib/schoolTime";

export default function App() {
  const { i18n } = useTranslation();
  // Every time on screen is shown on the school's own clock; an institution-bound login carries its zone.
  const timezone = useAppSelector((s) => s.auth.user?.institutionTimezone);
  useEffect(() => setSchoolTimezone(timezone), [timezone]);
  return <AppRoutes key={i18n.resolvedLanguage ?? i18n.language} />;
}